import { gamepadHandler } from "./gamepadEvents";
import { Keymap } from "../models/keymap";
import { Logger } from "./logger";
import { VideoplayerComponent } from "../videoplayer/videoplayer.component";

declare const document: any;

enum InputEvent {
  Keyboard = 0,
  Mouse = 1,
  MouseWheel = 2,
  Touch = 3,
  ButtonClick = 4,
  Gamepad = 5,
  ColorPick = 6,
  ThicknessSelect = 7,
  Text = 8,
  Json = 9,
}

enum KeyboardEventType {
  Up = 0,
  Down = 1,
}

enum GamepadEventType {
  ButtonUp = 0,
  ButtonDown = 1,
  ButtonPressed = 2,
  Axis = 3,
}

enum PointerPhase {
  None = 0,
  Began = 1,
  Moved = 2,
  Ended = 3,
  Canceled = 4,
  Stationary = 5,
}

let sendGamepadButtonDown: ((e: GamepadEvent) => void) | undefined;
let sendGamepadButtonUp: ((e: GamepadEvent) => void) | undefined;
let sendGamepadButtonPressed: ((e: GamepadEvent) => void) | undefined;
let gamepadAxisChange: ((e: GamepadEvent) => void) | undefined;
let gamepadConnected: ((e: GamepadEvent) => void) | undefined;
let gamepadDisconnected: ((e: GamepadEvent) => void) | undefined;

export function registerGamepadEvents(videoPlayer: any): void {
  const _videoPlayer = videoPlayer;

  unregisterGamepadEvents();

  // sendGamepadButtonDown = (e: GamepadEvent) => {
  sendGamepadButtonDown = (e: any) => {
    Logger.debug(
      `gamepad id: ${e.id} button index: ${e.index} value ${e.value} down`
    );
    let data = new DataView(new ArrayBuffer(19));
    data.setUint8(0, InputEvent.Gamepad);
    data.setUint8(1, GamepadEventType.ButtonDown);
    data.setUint8(2, e.index);
    data.setFloat64(3, e.value, true);

    _videoPlayer && _videoPlayer.sendMsg(data.buffer);
  };

  // sendGamepadButtonUp = (e: GamepadEvent) => {
  sendGamepadButtonUp = (e: any) => {
    Logger.debug(
      `gamepad id: ${e.id} button index: ${e.index} value ${e.value} up`
    );
    let data = new DataView(new ArrayBuffer(19));
    data.setUint8(0, InputEvent.Gamepad);
    data.setUint8(1, GamepadEventType.ButtonUp);
    data.setUint8(2, e.index);
    data.setFloat64(3, e.value, true);

    _videoPlayer && _videoPlayer.sendMsg(data.buffer);
  };

  // sendGamepadButtonPressed = (e: GamepadEvent) => {
    sendGamepadButtonPressed = (e: any) => {
      Logger.debug(
      `gamepad id: ${e.id} button index: ${e.index} value ${e.value} pressed`
    );
    let data = new DataView(new ArrayBuffer(19));
    data.setUint8(0, InputEvent.Gamepad);
    data.setUint8(1, GamepadEventType.ButtonPressed);
    data.setUint8(2, e.index);
    data.setFloat64(3, e.value, true);

    _videoPlayer && _videoPlayer.sendMsg(data.buffer);
  };

  // gamepadAxisChange = (e: GamepadEvent) => {
    gamepadAxisChange = (e: any) => {
      Logger.debug(
      `gamepad id: ${e.id} axis: ${e.index} value ${e.value} x: ${e.x} y: ${e.y}`
    );
    let data = new DataView(new ArrayBuffer(27));
    data.setUint8(0, InputEvent.Gamepad);
    data.setUint8(1, GamepadEventType.Axis);
    data.setUint8(2, e.index);
    data.setFloat64(3, e.x, true);
    data.setFloat64(11, e.y, true);
    _videoPlayer && _videoPlayer.sendMsg(data.buffer);
  };

  gamepadConnected = (e: GamepadEvent) => {
    gamepadHandler(e, true);
  };
  gamepadDisconnected = (e: GamepadEvent) => {
    gamepadHandler(e, false);
  };

  document.addEventListener("gamepadButtonDown", sendGamepadButtonDown, false);
  document.addEventListener("gamepadButtonUp", sendGamepadButtonUp, false);
  document.addEventListener(
    "gamepadButtonPressed",
    sendGamepadButtonPressed,
    false
  );
  document.addEventListener("gamepadAxis", gamepadAxisChange, false);

  window.addEventListener("gamepadconnected", gamepadConnected, false);
  window.addEventListener("gamepaddisconnected", gamepadDisconnected, false);
}

export function unregisterGamepadEvents(): void {
  document.removeEventListener(
    "gamepadButtonDown",
    sendGamepadButtonDown!,
    false
  );
  document.removeEventListener("gamepadButtonUp", sendGamepadButtonUp!, false);
  document.removeEventListener(
    "gamepadButtonPressed",
    sendGamepadButtonPressed!,
    false
  );
  document.removeEventListener("gamepadAxis", gamepadAxisChange!, false);

  window.removeEventListener("gamepadconnected", gamepadConnected!, false);
  window.removeEventListener(
    "gamepaddisconnected",
    gamepadDisconnected!,
    false
  );
}

let sendKeyUp: ((e: KeyboardEvent) => void) | undefined;
let sendKeyDown: ((e: KeyboardEvent) => void) | undefined;

export function registerKeyboardEvents(videoPlayer: any): void {
  const _videoPlayer = videoPlayer;

  unregisterKeyboardEvents();

  function sendKey(e: KeyboardEvent, type: KeyboardEventType): void {
    const key = Keymap[e.code];
    const character = e.key.length === 1 ? e.key.charCodeAt(0) : 0;
    Logger.debug(
      `key down ${key}, repeat = ${e.repeat}, character = ${character}`
    );
    _videoPlayer &&
      _videoPlayer.sendMsg(
        new Uint8Array([InputEvent.Keyboard, type, e.repeat, key, character])
          .buffer
      );
  }

  sendKeyUp = (e: KeyboardEvent) => {
    sendKey(e, KeyboardEventType.Up);
  };

  sendKeyDown = (e: KeyboardEvent) => {
    sendKey(e, KeyboardEventType.Down);
  };

  document.addEventListener("keyup", sendKeyUp, false);
  document.addEventListener("keydown", sendKeyDown, false);
}

export function unregisterKeyboardEvents(): void {
  document.removeEventListener("keyup", sendKeyUp!, false);
  document.removeEventListener("keydown", sendKeyDown!, false);
}

let sendMouse: ((e: MouseEvent) => void) | undefined;
let sendMouseClick: ((e: MouseEvent) => void) | undefined;
let sendMouseWheel: ((e: WheelEvent) => void) | undefined;
let sendTouchEnd: ((e: TouchEvent) => void) | undefined;
let sendTouchStart: ((e: TouchEvent) => void) | undefined;
let sendTouchCancel: ((e: TouchEvent) => void) | undefined;
let sendTouchMove: ((e: TouchEvent) => void) | undefined;

export function registerMouseEvents(
  videoPlayer: any,
  playerElement: HTMLElement
): void {

  unregisterMouseEvents(playerElement)
  const _videoPlayer = videoPlayer;

  function sendTouch(e: TouchEvent, phase: PointerPhase): void {
    const changedTouches = Array.from(e.changedTouches);
    const touches = Array.from(e.touches);
    const phrases: PointerPhase[] = [];

    for (let i = 0; i < changedTouches.length; i++) {
      if (
        touches.find((t) => t.identifier === changedTouches[i].identifier) ===
        undefined
      ) {
        touches.push(changedTouches[i]);
      }
    }

    for (let i = 0; i < touches.length; i++) {
      phrases[i] =
        changedTouches.find((e) => e.identifier === touches[i].identifier) ===
          undefined
          ? PointerPhase.Stationary
          : phase;
    }

    Logger.debug(
      `touch phase:${phase} length:${changedTouches.length} pageX${changedTouches[0].pageX}, pageY: ${changedTouches[0].pageY}, force:${changedTouches[0].force}`
    );

    let data = new DataView(new ArrayBuffer(2 + 13 * touches.length));
    data.setUint8(0, InputEvent.Touch);
    data.setUint8(1, touches.length);
    let byteOffset = 2;
    for (let i = 0; i < touches.length; i++) {
      const scale = _videoPlayer.videoScale;
      const originX = _videoPlayer.videoOriginX;
      const originY = _videoPlayer.videoOriginY;

      const x = (touches[i].pageX - originX) / scale;
      const y =
        _videoPlayer.videoHeight - (touches[i].pageY - originY) / scale;

      data.setInt32(byteOffset, touches[i].identifier, true);
      byteOffset += 4;
      data.setUint8(byteOffset, phrases[i]);
      byteOffset += 1;
      data.setInt16(byteOffset, x, true);
      byteOffset += 2;
      data.setInt16(byteOffset, y, true);
      byteOffset += 2;
      data.setFloat32(byteOffset, touches[i].force, true);
      byteOffset += 4;
    }
    _videoPlayer && _videoPlayer.sendMsg(data.buffer);
  }
  sendMouse = (e: MouseEvent) => {
    Logger.debug(`mouse event:${e.type} pageX:${e.pageX}, pageY:${e.pageY}`);
    const scale = _videoPlayer.videoScale;
    const originX = _videoPlayer.videoOriginX;
    const originY = _videoPlayer.videoOriginY;

    const x = (e.clientX - originX) / scale;
    // According to Unity Coordinate system
    // const y = (e.clientY - originY) / scale;
    const y = _videoPlayer.videoHeight - (e.clientY - originY) / scale;
    Logger.debug(`mouse event calc:${e.type} pageX:${x}, pageY:${e.pageY}, scale:${scale}, originX:${originX}, originY:${originY} x:${x}, y:${y}`);
    // Logger.debug(
    //   "x: " +
    //     x +
    //     ", y: " +
    //     y +
    //     ", scale: " +
    //     scale +
    //     ", originX: " +
    //     originX +
    //     ", originY: " +
    //     originY +
    //     " mouse button:" +
    //     e.buttons
    // );
    // Logger.debug('send mouse event', e.type, x, y);
    let data = new DataView(new ArrayBuffer(6));
    data.setUint8(0, InputEvent.Mouse);
    data.setInt16(1, x, true);
    data.setInt16(3, y, true);
    data.setUint8(5, e.buttons);
    _videoPlayer && _videoPlayer.sendMsg(data.buffer);

    // let data = new DataView(new ArrayBuffer(13));
    // data.setUint8(0, InputEvent.Mouse);
    // data.setUint8(1, e.button);
    // data.setUint8(2, e.type === "mouseup" ? 0 : 1);
    // data.setInt16(3, (e.pageX - originX) / scale, true);
    // data.setInt16(
    //   5,
    //   _videoPlayer.videoHeight - (e.pageY - originY) / scale,
    //   true
    // );
    // const evt: any = e;
    // // data.setFloat32(7, e.force || 0.5, true);
    // data.setFloat32(7, evt.force || 0.5, true);
    // data.setUint8(11, e.ctrlKey ? 1 : 0);
    // data.setUint8(12, e.shiftKey ? 1 : 0);

    // _videoPlayer && _videoPlayer.sendMsg(data.buffer);
  };

  sendMouseClick = (e: MouseEvent) => {
    console.log(`mouse event:${e.type} pageX:${e.pageX}, pageY:${e.pageY}`);
    const scale = _videoPlayer.videoScale;
    const originX = _videoPlayer.videoOriginX;
    const originY = _videoPlayer.videoOriginY;

    const x = (e.clientX - originX) / scale;
    const y = _videoPlayer.videoHeight - (e.clientY - originY) / scale;
    console.log(`mouse event calc:${e.type} clientX:${e.clientX}, clientY:${e.clientY}, scale:${scale}, originX:${originX}, originY:${originY} x:${x}, y:${y}`);
    let data = new DataView(new ArrayBuffer(6));
    data.setUint8(0, InputEvent.Mouse);
    data.setInt16(1, x, true);
    data.setInt16(3, y, true);
    data.setUint8(5, e.buttons);
    _videoPlayer && _videoPlayer.sendMsg(data.buffer);

  };

  

  sendMouseWheel = (e: any) => {
    Logger.debug("mouse wheel with delta " + e.wheelDelta);
    let data = new DataView(new ArrayBuffer(9));
    data.setUint8(0, InputEvent.MouseWheel);
    data.setFloat32(1, e.deltaX, true);
    data.setFloat32(5, e.deltaY, true);
    _videoPlayer && _videoPlayer.sendMsg(data.buffer);
  };

  sendTouchEnd = (e: TouchEvent) => {
    sendTouch(e, PointerPhase.Ended);
  };

  sendTouchStart = (e: TouchEvent) => {
    sendTouch(e, PointerPhase.Began);
  };

  sendTouchCancel = (e: TouchEvent) => {
    sendTouch(e, PointerPhase.Canceled);
  };

  sendTouchMove = (e: TouchEvent) => {
    sendTouch(e, PointerPhase.Moved);
  };

  playerElement.addEventListener("touchend", sendTouchEnd, false);
  playerElement.addEventListener("touchstart", sendTouchStart, false);
  playerElement.addEventListener("touchcancel", sendTouchCancel, false);
  playerElement.addEventListener("touchmove", sendTouchMove, false);

  // playerElement.addEventListener("mouseup", sendMouse, false);
  // playerElement.addEventListener("mousedown", sendMouse, false);
  // playerElement.addEventListener("click", sendMouse, false);
  // playerElement.addEventListener("mousemove", sendMouse, false);

  playerElement.addEventListener("mouseup", sendMouseClick, false);
  playerElement.addEventListener("mousedown", sendMouseClick, false);
  playerElement.addEventListener("click", sendMouseClick, false);
  playerElement.addEventListener("mousemove", sendMouse, false);


  playerElement.addEventListener("wheel", sendMouseWheel, false);
}

export function unregisterMouseEvents(playerElement: HTMLElement): void {
  playerElement.removeEventListener("touchend", sendTouchEnd!, false);
  playerElement.removeEventListener("touchstart", sendTouchStart!, false);
  playerElement.removeEventListener("touchcancel", sendTouchCancel!, false);
  playerElement.removeEventListener("touchmove", sendTouchMove!, false);

  // playerElement.removeEventListener("mouseup", sendMouse!, false);
  // playerElement.removeEventListener("mousedown", sendMouse!, false);
  playerElement.removeEventListener("mouseup", sendMouseClick!, false);
  playerElement.removeEventListener("mousedown", sendMouseClick!, false);

  playerElement.removeEventListener("wheel", sendMouseWheel!, false);
}

let sendClick: ((e: MouseEvent) => void) | undefined;

// export function registerClickEvents(videoPlayer: any): void {
//   const _videoPlayer = videoPlayer;

//   sendClick = (e: MouseEvent) => {
//     const target = e.target as HTMLElement;
//     Logger.debug(
//       `click event:${e.type} pageX:${e.pageX}, pageY:${e.pageY}, id: ${target?.id}`
//     );

//     let data = new DataView(new ArrayBuffer(13));
//     data.setUint8(0, InputEvent.ButtonClick);
//     data.setUint8(1, e.button);
//     data.setUint8(2, e.type === "mouseup" ? 0 : 1);
//     data.setInt16(3, e.pageX, true);
//     data.setInt16(5, e.pageY, true);
//     data.setUint8(7, e.ctrlKey ? 1 : 0);
//     data.setUint8(8, e.shiftKey ? 1 : 0);

//     _videoPlayer && _videoPlayer.sendMsg(data.buffer);
//   };

//   document.addEventListener("mouseup", sendClick, false);
//   document.addEventListener("mousedown", sendClick, false);
// }

// export function unregisterClickEvents(): void {
//   document.removeEventListener("mouseup", sendClick!, false);
//   document.removeEventListener("mousedown", sendClick!, false);
// }


export function sendClickEvent(videoPlayer: any, elementId: number) {
  let data = new DataView(new ArrayBuffer(3));
  data.setUint8(0, InputEvent.ButtonClick);
  data.setInt16(1, elementId, true);
  videoPlayer && videoPlayer.sendMsg(data.buffer);
}

export function sendColor(videoPlayer: any, hexColor: string) {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);

  let data = new DataView(new ArrayBuffer(4));
  data.setUint8(0, InputEvent.ColorPick);
  data.setUint8(1, r);
  data.setUint8(2, g);
  data.setUint8(3, b);

  videoPlayer && videoPlayer.sendMsg(data.buffer);
}

export function sendThickness(videoPlayer: any, thickness: string) {
  sendInt32Value(videoPlayer, InputEvent.ThicknessSelect, parseInt(thickness));
}

export function sendInt32Value(videoPlayer: any, inputEvent: number, int32Value: number) {
  let data = new DataView(new ArrayBuffer(5));
  data.setUint8(0, inputEvent /*InputEvent.ButtonClick*/);
  data.setInt32(1, int32Value, true);
  videoPlayer && videoPlayer.sendMsg(data.buffer);
}


  /**
   * Sends a JSON string message to the video player.
   * The JSON string is a wrapper for a list of text lines.
   * The text lines are split using the following separators:
   * - \r
   * - \n
   * - \r\n
   * Empty lines are filtered out.
   * @param {any} videoPlayer - The video player to send the message to.
   * @param {string} text - The text to send.
   */
export function sendJson(videoPlayer: VideoplayerComponent, text: string) {
  let separators = /[\r\n]+/;
  let rows = text.split(separators);
  rows = rows.filter((line) => line.trim() !== "");

  let jsonObject = {
    Links: rows,
  };
  let jsonString = JSON.stringify(jsonObject);
  let textLen = jsonString.length;
  let data = new DataView(new ArrayBuffer(textLen + 1));

  data.setUint8(0, InputEvent.Json);

  for (let i = 0; i < textLen; i++) {
    data.setUint8(i + 1, jsonString[i].charCodeAt(0));
  }
  videoPlayer && videoPlayer.sendMsg(data.buffer);
}

/**
 * Sends a JSON array message to the video player.
 * The JSON array contains a list of text strings.
 * Empty strings are filtered out before sending.
 * @param {any} videoPlayer - The video player to send the message to.
 * @param {string[]} texts - The array of text strings to send.
 */

export function sendJsonArray(videoPlayer: VideoplayerComponent, texts: string[]) {

  if(!texts || !texts.length) {
    return false;
  }

  texts = texts.filter((line) => line.trim() !== "");

  let jsonObject = {
    Links: texts,
  };
  let jsonString = JSON.stringify(jsonObject);
  let textLen = jsonString.length;
  let data = new DataView(new ArrayBuffer(textLen + 1));

  data.setUint8(0, InputEvent.Json);

  for (let i = 0; i < textLen; i++) {
    data.setUint8(i + 1, jsonString[i].charCodeAt(0));
  }
  if(!videoPlayer) {
    return false;
  } 
  return videoPlayer.sendMsg(data.buffer);
}

export function sendText(videoPlayer: any, text: string): boolean {
  // The headset decodes the base64 as UTF-8: accented letters must be encoded the same way (btoa alone is Latin-1)
  let binary = '';
  new TextEncoder().encode(text).forEach(byte => binary += String.fromCharCode(byte));
  const base64 = btoa(binary);
  const data = new DataView(new ArrayBuffer(base64.length + 1));
  data.setUint8(0, InputEvent.Text);
  for (let i = 0; i < base64.length; i++) {
    data.setUint8(i + 1, base64.charCodeAt(i));
  }
  return !!videoPlayer && videoPlayer.sendMsg(data.buffer) === true;
}
